var _excluded = ["header", "content", "footer", "showMoreDetails", "pushTopSpace", "minWidth", "hasHeaderBottomBar", "ariaLabels"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
import useDeviceDetect from "../../../hooks/useDeviceDetect";
import useLargeZoom from "../../../hooks/useLargeZoom";
import { spaceFactor } from "../../../utils/space";
import { biggerScreenBreakpoint } from "./common";
import Content from "./Content";
import Footer from "./Footer";
import FooterButton from "./FooterButton";
import Header from "./Header";
import { Table, Wrapper } from "./TableMol.styled";
/* eslint-disable react/no-array-index-key */
function TableMol(_ref) {
  var header = _ref.header,
    content = _ref.content,
    footer = _ref.footer,
    showMoreDetails = _ref.showMoreDetails,
    pushTopSpace = _ref.pushTopSpace,
    minWidth = _ref.minWidth,
    _ref$hasHeaderBottomB = _ref.hasHeaderBottomBar,
    hasHeaderBottomBar = _ref$hasHeaderBottomB === void 0 ? false : _ref$hasHeaderBottomB,
    ariaLabels = _ref.ariaLabels,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var wrapperRef = useRef(null);
  var headerRef = useRef(null);
  var timeoutRef = useRef(null);
  var isBiggerScreen = useBreakpoint(biggerScreenBreakpoint);
  var _useDeviceDetect = useDeviceDetect(),
    isIOS = _useDeviceDetect.isIOS;
  var headerColumns = header.columns;
  var numberOfColumns = (headerColumns === null || headerColumns === void 0 ? void 0 : headerColumns.length) || 1;
  var activeColumnIndex = headerColumns && headerColumns.findIndex(function (_ref2) {
    var isActive = _ref2.isActive;
    return isActive;
  });
  activeColumnIndex = activeColumnIndex === -1 ? undefined : activeColumnIndex;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHeaderSticky = _useState2[0],
    setIsHeaderSticky = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    headerOffsetTop = _useState4[0],
    setHeaderOffsetTop = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    headerHasBeenSticky = _useState6[0],
    setHeaderHasBeenSticky = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    headerHeight = _useState8[0],
    setHeaderHeight = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    tableWidth = _useState10[0],
    setTableWidth = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    tableHorizontalScrollValue = _useState12[0],
    setTableHorizontalScrollValue = _useState12[1];
  var isLargeZoom = useLargeZoom();
  var getVisibleStickyElementsHeight = useCallback(function () {
    return pushTopSpace ? pushTopSpace * spaceFactor : 0;
  }, [pushTopSpace]);
  var setIfHeaderShouldBeSticky = useCallback(function () {
    var additionalSafeSpace = 10;
    if (isLargeZoom) {
      setIsHeaderSticky(false);
      return;
    }
    var isTableAboveVisibleViewport = wrapperRef.current && wrapperRef.current.getBoundingClientRect().top < getVisibleStickyElementsHeight();
    var isThereEnoughRemainingSpace = wrapperRef.current && wrapperRef.current.getBoundingClientRect().bottom > headerHeight + additionalSafeSpace * spaceFactor;
    setIsHeaderSticky(!!(isTableAboveVisibleViewport && isThereEnoughRemainingSpace));
  }, [getVisibleStickyElementsHeight, headerHeight, isLargeZoom]);
  var setTableWidthValue = function setTableWidthValue() {
    var wrapperRefCurrent = wrapperRef.current;
    setTableWidth(wrapperRefCurrent ? wrapperRefCurrent.offsetWidth : 0);
  };
  var setHeaderHeightValue = function setHeaderHeightValue() {
    var headerRefCurrent = headerRef.current;
    setHeaderHeight(headerRefCurrent ? headerRefCurrent.offsetHeight : 0);
  };

  /**
   * 1. Fixes problem with a stuttering sticky header on iOS devices due to momentum scroll behavior
   */
  var handleTableScroll = function handleTableScroll() {
    var wrapperRefCurrent = wrapperRef.current;
    var scrollLeftValue = wrapperRefCurrent ? wrapperRefCurrent.scrollLeft : 0;
    scrollLeftValue = scrollLeftValue < 0 ? 0 : scrollLeftValue;
    if (!isIOS) {
      setTableHorizontalScrollValue(scrollLeftValue);
    } else {
      /* 1 */
      var allowableScrollDifferenceOnIOS = 10;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      var timeoutId = window.setTimeout(function () {
        if (Math.abs(tableHorizontalScrollValue - scrollLeftValue) > allowableScrollDifferenceOnIOS) {
          setTableHorizontalScrollValue(scrollLeftValue);
        }
      }, 40);
      timeoutRef.current = timeoutId;
    }
  };
  var handleDocumentScroll = useCallback(function () {
    setHeaderOffsetTop(getVisibleStickyElementsHeight());
    setHeaderHasBeenSticky(isHeaderSticky);
    setIfHeaderShouldBeSticky();
  }, [getVisibleStickyElementsHeight, isHeaderSticky, setIfHeaderShouldBeSticky]);
  var handleWindowResize = useCallback(function () {
    setTableWidthValue();
    setHeaderHeightValue();
    setIfHeaderShouldBeSticky();
  }, [setIfHeaderShouldBeSticky]);
  useEffect(function () {
    setTableWidthValue();
    setHeaderHeightValue();
    document.addEventListener("touchmove", handleDocumentScroll);
    document.addEventListener("scroll", handleDocumentScroll);
    window.addEventListener("resize", handleWindowResize);
    return function () {
      document.removeEventListener("touchmove", handleDocumentScroll);
      document.removeEventListener("scroll", handleDocumentScroll);
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleDocumentScroll, handleWindowResize]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, restProps, {
    "data-test-id": "table",
    ref: wrapperRef,
    onScroll: handleTableScroll
  }), /*#__PURE__*/React.createElement(Table, {
    $numberOfColumns: numberOfColumns,
    $isHeaderSticky: isHeaderSticky,
    $headerHeight: headerHeight,
    $onColor: onColor,
    $minWidth: minWidth,
    $hasFullWidthHeader: !!headerColumns,
    role: "table",
    "aria-label": ariaLabels.tableLabel
  }, /*#__PURE__*/React.createElement(Header, {
    label: header.label,
    columns: headerColumns,
    isSticky: isHeaderSticky,
    hasBeenSticky: headerHasBeenSticky,
    offsetTop: headerOffsetTop,
    minWidth: minWidth,
    tableHorizontalScrollValue: tableHorizontalScrollValue,
    numberOfColumns: numberOfColumns,
    tableWidth: tableWidth,
    isBiggerScreen: isBiggerScreen,
    onColor: onColor,
    ref: headerRef,
    hasHeaderBottomBar: hasHeaderBottomBar,
    ariaLabels: {
      rowLabel: ariaLabels.rowLabel,
      columnHeaderLabel: ariaLabels.columnHeaderLabel
    }
  }), /*#__PURE__*/React.createElement(Content, {
    groups: content,
    activeColumnIndex: activeColumnIndex,
    isBiggerScreen: isBiggerScreen,
    showMoreDetails: showMoreDetails,
    numberOfColumns: numberOfColumns,
    tableHasFooter: !!footer,
    ariaLabels: {
      rowGroupLabel: ariaLabels.rowGroupLabel,
      rowLabel: ariaLabels.rowLabel,
      cellLabel: ariaLabels.cellLabel,
      iconTrueAriaLabel: ariaLabels.iconTrueAriaLabel,
      iconFalseAriaLabel: ariaLabels.iconFalseAriaLabel
    }
  }), isBiggerScreen && footer ? /*#__PURE__*/React.createElement(Footer, {
    footer: footer,
    activeColumnIndex: activeColumnIndex,
    numberOfColumns: numberOfColumns,
    rowAriaLabel: ariaLabels.rowLabel,
    cellAriaLabel: ariaLabels.cellLabel
  }) : null));
}
TableMol.FooterButton = FooterButton;
export default TableMol;